import { Text, View } from '@react-pdf/renderer';

export default function SignBlock() {
    const signBlock = {
        flexGrow: '1',
        display: 'flex',
        justifyContent: 'center',
        //backgroundColor: 'blue'
    }

    const signRow = {

        paddingTop: '0px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-evenly',
        //backgroundColor: 'beige'
    }

    const item = {
        display: 'flex',
        textAlign: 'center',
        alignItems: 'center',
        gap: '4px'
        //height: '100%'
    }

    const signLine = {
        width: '200px',
        height: '1px',
        backgroundColor: 'black'
    }
    return (
        <View style={signBlock}>
            <View style={signRow}>
                <View style={item}>
                    <View style={signLine}></View>
                    <Text>Nombre y firma del cliente</Text>
                </View>

                <View style={item}>
                    <View style={signLine}></View>
                    <Text>Peicar{'\n'}</Text>
                </View>
            </View>
        </View>
    )
}
